/**
 * Calculate the difference in seconds between two timestamps
 * @param {number} timeLeft - The later timestamp
 * @param {number} timeRight - The earlier timestamp
 * @returns {number} The number of seconds between the timestamps
 */
const differenceInSeconds = (timeLeft, timeRight) => {
  return Math.floor((timeLeft - timeRight) / 1000);
};

/**
 * @desc - takes a lastFetched date/timestamp and an expiryInterval in minutes and returns a Boolean indicating if the data is expired
 * @param {Date | number | null | undefined} lastFetched - a Date object or epoch-ms timestamp representing the last time a data set was fetched
 * @param {number} expiryInterval - a number which represents the age in minutes when a data set is considered expired
 * @example isDataExpired(<DATE>, 1440)
 */
export const isDataExpired = (lastFetched, expiryInterval) => {
  if (!lastFetched) return true;

  const currentTime = Date.now();
  const dataAgeMinutes = differenceInSeconds(currentTime, lastFetched) / 60;

  // if the data is older than its expiry time then it is expired
  return Boolean(dataAgeMinutes > expiryInterval);
};

const reduxStoreExpiry = { isDataExpired };

export default reduxStoreExpiry;
